<template>
	<div class="section-banner">
		<v-layout wrap>
			<v-flex xs12 md6>
				<div class="text-align-c-m">
					<img src="/static/images-new/logos/logo-casamarket.svg" alt="" class="mb-2">
				</div>
				<p class="text-subtitle text-align-c-m">Hacia la transformación digital</p>
				<p class="text-asesor text-align-c-m" v-if="adviser.name">
					<span class="text-green">HOLA,</span>
					SOY {{ adviser.name }},
					{{ adviser.sexo === 'F'? 'Ejecutiva' : 'Ejecutivo'}} DE CASAMARKET
				</p>
				<p class="text-asesor text-align-c-m" v-else>
					<span class="text-green">HOLA,</span>
					SOY EJECUTIVO<br/>DE CASAMARKET
				</p>
				<p class="text-help text-align-c-m br-desktop">Permíteme ayudarte con cualquier <br/>
					consulta que tengas</p>
			</v-flex>
			<v-flex xs12 md6>
				<div>
					<form-asesor :adviser="adviser"/>
				</div>
			</v-flex>
		</v-layout>
		<div class="container-image">
			<img src="/static/images-new/sections/asesor.png" alt="asesor" class="image">
		</div>
	</div>
</template>
<script>
import formAsesor from '@/components/advisers/form-asesor';

export default {
	name: 'section-banner',
	components: {
		formAsesor,
	},
	props: {
		adviser: {
			type: Object,
			default: () => {},
		},
	},
};

</script>
<style lang="scss" scoped>
	.section-banner {
		background-image: url('/static/images-new/banners/banner-desktop.png');
		height: calc(100vh - 94px);
		padding: 40px 9% 0 9%;

		@media (max-width: 962px) {
			height: auto;
		}
	}

	.text-subtitle {
		color: color(newwarning);
		font-size: 18px;

		@media (max-width: 936px) {
			font-size: 15px;
		}
	}

	.text-asesor {
		color: color(newwarning);
		font-size: 40px;
		font-weight: 900;
		max-width: 365px;
		text-transform: uppercase;

		@media (max-width: 936px) {
			font-size: 18px;
			font-weight: 800;
			margin: 28px auto;
			max-width: 250px;
		}
	}

	.text-green {
		color: color(primary);
	}

	.text-help {
		color: color(newwarning);
		font-size: 20px;
	}

	.text-align-c-m {
		@media (max-width: 962px) {
			text-align: center;
		}
	}

	.container-image {
		position: absolute;
		bottom: 0;
		left: 37%;

		@media (max-width: 1145px) {
			display: none;
		}
	}

	.image {
		height: 70vh;
	}
</style>


// WEBPACK FOOTER //
// src/components/advisers/section-banner.vue